import {type ReactNode} from 'react'

import {H1, Lead} from '#app/ui/typography'
import {cn} from '#app/utils/misc'

export function Container({children, className}: {children: ReactNode; className?: string}) {
  return <main className={cn('container space-y-8', className)}>{children}</main>
}

function Header({
  title,
  subtitle,
  className,
  bottomMargin = false,
}: {
  title: string
  subtitle: string
  className?: string
  bottomMargin?: boolean
}) {
  return (
    <div className={cn('max-w-prose', className, bottomMargin && 'mb-8')}>
      <H1>{title}</H1>
      <Lead>{subtitle}</Lead>
    </div>
  )
}

export const Page = {
  Container,
  Header,
}
